import { render, staticRenderFns } from "./socket.vue?vue&type=template&id=3d212d1f&"
import script from "./socket.vue?vue&type=script&lang=js&"
export * from "./socket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports